import { useState, FormEvent } from 'react';
import { useAuth } from '../hooks/useAuth';

const T = {
  bg: '#080706', panel: '#141310', card: '#1a1815', border: '#2a2620',
  copper: '#e8935a', sage: '#7eb89a', text: '#f0ebe4', sub: '#8a8178', dim: '#4a4540',
  crimson: '#c0454a',
};

export default function LoginPage() {
  const { login } = useAuth();
  const [email,    setEmail]    = useState('');
  const [password, setPassword] = useState('');
  const [error,    setError]    = useState('');
  const [loading,  setLoading]  = useState(false);

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await login(email, password);
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Login failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{
      minHeight: '100vh', background: T.bg,
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      fontFamily: "'DM Sans', sans-serif",
    }}>
      <div style={{
        width: 420, background: T.panel,
        border: `1px solid ${T.border}`, borderRadius: 16,
        padding: '40px 36px',
        boxShadow: '0 40px 80px rgba(0,0,0,.6)',
      }}>
        {/* Logo */}
        <div style={{ textAlign: 'center', marginBottom: 32 }}>
          <div style={{
            width: 52, height: 52, borderRadius: 14, margin: '0 auto 16px',
            background: `linear-gradient(135deg, ${T.copper}, #d4a847)`,
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            fontSize: 26, boxShadow: `0 0 32px ${T.copper}40`,
          }}>◎</div>
          <div style={{ fontFamily: "'Fraunces', serif", fontWeight: 700, fontSize: 24, color: T.text, letterSpacing: -.4 }}>
            TraceFull
          </div>
          <div style={{ color: T.sub, fontSize: 12, marginTop: 6 }}>
            Enterprise Supply Chain Intelligence
          </div>
        </div>

        <form onSubmit={handleSubmit}>
          <div style={{ marginBottom: 16 }}>
            <label style={{ display: 'block', color: T.sub, fontSize: 11, fontWeight: 600, letterSpacing: .8, textTransform: 'uppercase', marginBottom: 7 }}>
              Email
            </label>
            <input
              type="email"
              value={email}
              onChange={e => setEmail(e.target.value)}
              placeholder="you@company.com"
              required
              style={{
                width: '100%', background: T.card, border: `1px solid ${T.border}`,
                borderRadius: 9, padding: '11px 14px', color: T.text, fontSize: 14,
                outline: 'none', fontFamily: "'DM Sans', sans-serif",
                transition: 'border-color .15s',
              }}
              onFocus={e => (e.target.style.borderColor = T.copper)}
              onBlur={e  => (e.target.style.borderColor = T.border)}
            />
          </div>

          <div style={{ marginBottom: 24 }}>
            <label style={{ display: 'block', color: T.sub, fontSize: 11, fontWeight: 600, letterSpacing: .8, textTransform: 'uppercase', marginBottom: 7 }}>
              Password
            </label>
            <input
              type="password"
              value={password}
              onChange={e => setPassword(e.target.value)}
              placeholder="Enter your password"
              required
              style={{
                width: '100%', background: T.card, border: `1px solid ${T.border}`,
                borderRadius: 9, padding: '11px 14px', color: T.text, fontSize: 14,
                outline: 'none', fontFamily: "'DM Sans', sans-serif",
                transition: 'border-color .15s',
              }}
              onFocus={e => (e.target.style.borderColor = T.copper)}
              onBlur={e  => (e.target.style.borderColor = T.border)}
            />
          </div>

          {error && (
            <div style={{
              background: `${T.crimson}15`, border: `1px solid ${T.crimson}40`,
              borderRadius: 8, padding: '10px 14px', color: T.crimson,
              fontSize: 12, marginBottom: 18,
            }}>
              {error}
            </div>
          )}

          <button
            type="submit"
            disabled={loading}
            style={{
              width: '100%', padding: '13px',
              background: loading ? T.border : `linear-gradient(135deg, ${T.copper}, #d4a847)`,
              border: 'none', borderRadius: 10, color: loading ? T.sub : '#1a0f00',
              fontWeight: 700, fontSize: 14, cursor: loading ? 'not-allowed' : 'pointer',
              fontFamily: "'DM Sans', sans-serif", letterSpacing: .3,
              transition: 'all .15s',
            }}
          >
            {loading ? 'Signing in…' : 'Sign In'}
          </button>
        </form>

        <div style={{ textAlign: 'center', marginTop: 18, fontSize: 13, color: T.sub }}>
          No account?{' '}
          <a
            href="#register"
            style={{ color: T.copper, fontWeight: 600, textDecoration: 'none' }}
          >
            Start free trial →
          </a>
        </div>
      </div>
    </div>
  );
}
